import { IconsProps } from '@/types/shared'
import React from 'react'

const CelebrationIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M1.22998 22.27L15.23 17.27L6.22998 8.26998L1.22998 22.27ZM11.58 16.45L4.52998 18.97L7.04998 11.92L11.58 16.45Z"
                    fill="currentColor"
                />
                <path
                    d="M13.76 12.8L19.35 7.20998C19.84 6.71998 20.63 6.71998 21.12 7.20998L21.71 7.79998L22.77 6.73998L22.18 6.14998C21.11 5.07998 19.36 5.07998 18.29 6.14998L12.7 11.74L13.76 12.8Z"
                    fill="currentColor"
                />
                <path
                    d="M9.28998 7.14998L8.69998 7.73998L9.75998 8.79998L10.35 8.20998C11.42 7.13998 11.42 5.38998 10.35 4.31998L9.75998 3.72998L8.69998 4.79998L9.28998 5.38998C9.76998 5.86998 9.76998 6.66998 9.28998 7.14998Z"
                    fill="currentColor"
                />
                <path
                    d="M16.29 12.15L14.7 13.74L15.76 14.8L17.35 13.21C17.84 12.72 18.63 12.72 19.12 13.21L20.73 14.82L21.79 13.76L20.18 12.15C19.1 11.08 17.36 11.08 16.29 12.15Z"
                    fill="currentColor"
                />
                <path
                    d="M14.29 6.14998L10.7 9.73998L11.76 10.8L15.35 7.20998C16.42 6.13998 16.42 4.38998 15.35 3.31998L13.76 1.72998L12.7 2.78998L14.29 4.37998C14.77 4.86998 14.77 5.66998 14.29 6.14998Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default CelebrationIcons
